export const spacing = {
  px: "1px",
  0.5: "calc(var(--base-spacing) / 10)",
  1: "calc(var(--base-spacing) / 4)",
  1.5: "calc(var(--base-spacing) / 8 * 3)",
  2: "calc(var(--base-spacing) / 12 * 6)",
  2.5: "calc(var(--base-spacing) / 4 * 5)",
  3: "var(--m)",
  3.5: "calc(var(--m) + var(--base-spacing) / 8)",
  4: "calc(var(--m) * 1.5)",
  5: "calc(var(--base-spacing) * 5 / 4)",
  6: "var(--m-xxl)",
  7: "calc(var(--m-xxxl) + var(--base-spacing) / 8)",
  8: "calc(var(--m-xxl) * 1.25)",
  9: "calc(var(--m-xxl) * 1.5)",
  10: "calc(var(--m-xxl) * 1.75)",
  12: "calc(var(--m-xxl) * 2)",
  14: "calc(var(--m-xxl) * 2.5)",
  16: "calc(var(--m-xxl) * 3)",
  20: "calc(var(--m-xxl) * 4)",
  24: "calc(var(--m-xxl) * 5)",
  28: "calc(var(--m-xxl) * 6)",
  32: "calc(var(--m-xxl) * 7)",
  36: "calc(var(--m-xxl) * 8)",
  40: "calc(var(--m-xxl) * 9)",
  44: "calc(var(--m-xxl) * 10)",
  48: "calc(var(--m-xxl) * 11)",
  52: "calc(var(--m-xxl) * 12)",
  56: "calc(var(--m-xxl) * 13)",
  60: "calc(var(--m-xxl) * 14)",
  64: "calc(var(--m-xxl) * 15)",
  72: "calc(var(--m-xxl) * 18)",
  80: "calc(var(--m-xxl) * 20)",
  96: "calc(var(--m-xxl) * 24)",
};
